// src/pages/logistica/FillRate.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

export default function FillRate() {
  const [semanal, setSemanal] = useState([]);
  const [semanaSeleccionada, setSemanaSeleccionada] = useState(null); // null = la más reciente
  const [porCliente, setPorCliente] = useState([]);
  const [semanaMostrada, setSemanaMostrada] = useState(null);
  const [clienteExpandido, setClienteExpandido] = useState(null);
  const [lineasCliente, setLineasCliente] = useState([]);
  const [cargandoLineas, setCargandoLineas] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [sincronizando, setSincronizando] = useState(false);
  const [mensaje, setMensaje] = useState(null);
  const [rangoDesde, setRangoDesde] = useState('');
  const [rangoHasta, setRangoHasta] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [resultadosBusqueda, setResultadosBusqueda] = useState(null); // null = no hay búsqueda activa
  const [buscando, setBuscando] = useState(false);

  async function cargarSemanal() {
    const params = rangoDesde && rangoHasta ? { desde: rangoDesde, hasta: rangoHasta } : { semanas: 12 };
    const res = await api.get('/api/logistica/fillrate/semanal', { params });
    setSemanal(res.data.data);
  }

  async function cargarPorCliente(semana) {
    const res = await api.get('/api/logistica/fillrate/por-cliente', semana ? { params: { semana } } : {});
    setPorCliente(res.data.data);
    setSemanaMostrada(res.data.semana);
  }

  async function cargarTodo() {
    try {
      setCargando(true);
      await Promise.all([cargarSemanal(), cargarPorCliente(semanaSeleccionada)]);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargarTodo(); }, []); // eslint-disable-line

  async function handleClickSemana(semana) {
    setClienteExpandido(null);
    setSemanaSeleccionada(semana);
    setCargando(true);
    try {
      await cargarPorCliente(semana);
    } finally {
      setCargando(false);
    }
  }

  async function handleClickCliente(cliente) {
    if (clienteExpandido === cliente) {
      setClienteExpandido(null);
      return;
    }
    setClienteExpandido(cliente);
    try {
      setCargandoLineas(true);
      const res = await api.get('/api/logistica/fillrate/lineas', { params: { semana: semanaMostrada, cliente } });
      setLineasCliente(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargandoLineas(false);
    }
  }

  async function handleBuscarRango() {
    if (!rangoDesde || !rangoHasta) return;
    setCargando(true);
    try {
      await cargarSemanal();
    } finally {
      setCargando(false);
    }
  }

  function handleLimpiarRango() {
    setRangoDesde('');
    setRangoHasta('');
    cargarSemanal();
  }

  async function handleBuscar() {
    if (!busqueda.trim()) return;
    try {
      setBuscando(true);
      const res = await api.get('/api/logistica/fillrate/buscar', { params: { q: busqueda.trim() } });
      setResultadosBusqueda(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setBuscando(false);
    }
  }

  function handleLimpiarBusqueda() {
    setBusqueda('');
    setResultadosBusqueda(null);
  }

  async function handleSincronizar() {
    try {
      setSincronizando(true);
      setMensaje(null);
      await api.post('/api/logistica/fillrate/sync');
      await cargarTodo();
      setMensaje({ tipo: 'ok', texto: '✓ Sincronizado con NetSuite (Órdenes + Facturas).' });
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: 'No se pudo sincronizar.' });
    } finally {
      setSincronizando(false);
    }
  }

  if (cargando && semanal.length === 0) return <div style={styles.contenedor}>Cargando...</div>;

  return (
  <div style={styles.contenedor} className="contenedor-captura">
      <div style={styles.encabezado}>
        <div>
          <h1 style={styles.titulo}>Fill Rate</h1>
          <p style={styles.subtitulo}>Cajas facturadas vs solicitadas, solo pedidos cuya fecha de compromiso ya venció. Click en una semana para ver el desglose por cliente.</p>
        </div>
        <button onClick={handleSincronizar} disabled={sincronizando} style={styles.botonSync}>
          {sincronizando ? 'Sincronizando...' : '↻ Sincronizar con NetSuite'}
        </button>
      </div>

      <div style={styles.cajaBusqueda}>
        <input
          type="text"
          placeholder="Buscar por Num OC o Cliente…"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleBuscar()}
          style={styles.inputBusqueda}
        />
        <button onClick={handleBuscar} disabled={buscando || !busqueda.trim()} style={styles.botonBuscar}>
          {buscando ? 'Buscando...' : 'Buscar'}
        </button>
        {resultadosBusqueda !== null && (
          <button onClick={handleLimpiarBusqueda} style={styles.botonQuitarFiltro}>quitar búsqueda</button>
        )}
      </div>

      {resultadosBusqueda !== null && (
        <div style={styles.tarjeta}>
          <div style={styles.seccionTitulo}>Resultados de búsqueda ({resultadosBusqueda.length})</div>
          {resultadosBusqueda.length === 0 ? (
            <p style={{ color: '#8A7690', fontSize: '12px' }}>Sin resultados para "{busqueda}".</p>
          ) : (
            <div className='tabla-scroll'>
              <table style={styles.tabla}>
                <thead>
                  <tr>
                    <th style={styles.th}>Num OC</th>
                    <th style={styles.th}>Cliente</th>
                    <th style={styles.th}>Artículo</th>
                    <th style={styles.th}>Unidad</th>
                    <th style={styles.th}>Vence</th>
                    <th style={styles.thNum}>Solicitado</th>
                    <th style={styles.thNum}>Facturado</th>
                    <th style={styles.thNum}>Fill Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {resultadosBusqueda.map((r, idx) => (
                    <tr key={idx}>
                      <td style={styles.td}>{r.numero_oc}</td>
                      <td style={styles.td}>{r.cliente}</td>
                      <td style={styles.td}>{r.articulo}</td>
                      <td style={styles.td}>{r.unidad_venta || '—'}</td>
                      <td style={styles.td}>{r.fecha_venc_oc ? new Date(r.fecha_venc_oc).toLocaleDateString('es-MX') : '—'}</td>
                      <td style={styles.tdNum}>{Number(r.cantidad_solicitada).toLocaleString('es-MX')}</td>
                      <td style={styles.tdNum}>{Number(r.cantidad_facturada).toLocaleString('es-MX')}</td>
                      <td style={{ ...styles.tdNum, fontWeight: 700, color: r.fill_rate_linea >= 100 ? '#3E7C5A' : '#B23A48' }}>
                        {r.fill_rate_linea}%
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>  
          )}
        </div>
      )}

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      <div style={styles.tarjeta}>
        <div style={styles.seccionTitulo}>
          {rangoDesde && rangoHasta ? `${semanal.length} semanas en el rango` : `Últimas ${semanal.length} semanas`}
        </div>
        <div style={styles.filtroFechas}>
          <input type="date" value={rangoDesde} onChange={(e) => setRangoDesde(e.target.value)} style={styles.inputFecha} />
          <span style={{ color: '#8A7690', fontSize: '12px' }}>a</span>
          <input type="date" value={rangoHasta} onChange={(e) => setRangoHasta(e.target.value)} style={styles.inputFecha} />
          <button onClick={handleBuscarRango} disabled={!rangoDesde || !rangoHasta} style={styles.botonBuscar}>Buscar</button>
          {rangoDesde && rangoHasta && (
            <button onClick={handleLimpiarRango} style={styles.botonQuitarFiltro}>últimas 12 semanas</button>
          )}
        </div>
        <div style={styles.historicoTabla}>
          {semanal.map((s) => {
            const activa = semanaMostrada && new Date(s.semana).toDateString() === new Date(semanaMostrada).toDateString();
            return (
              <div
                key={s.semana}
                onClick={() => handleClickSemana(s.semana)}
                style={{ ...styles.historicoFila, ...(activa ? styles.historicoFilaActiva : {}) }}
              >
                <span style={styles.historicoFecha}>{new Date(s.semana).toLocaleDateString('es-MX', { day: '2-digit', month: 'short' })}</span>
                <div style={styles.barraFondo}>
                  <div style={{ ...styles.barraLlena, width: `${Math.min(s.pct_fill_rate, 100)}%`, background: s.pct_fill_rate >= 95 ? '#3E7C5A' : s.pct_fill_rate >= 85 ? '#D6A644' : '#B23A48' }} />
                </div>
                <span style={styles.historicoPct}>{s.pct_fill_rate}%</span>
                <span style={styles.historicoLineas}>{s.lineas} líneas</span>
              </div>
            );
          })}
        </div>
      </div>

      <div style={styles.tarjeta}>
        <div style={styles.seccionTitulo}>
          Por cliente {semanaMostrada && `— semana del ${new Date(semanaMostrada).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}`}
          {semanaSeleccionada && (
            <button onClick={() => handleClickSemana(null)} style={styles.botonQuitarFiltro}>ver semana más reciente</button>
          )}
        </div>
        {porCliente.length === 0 && <p style={{ color: '#8A7690', fontSize: '12px' }}>Sin datos para esta semana.</p>}
        <div className="tabla-scroll">
          <table style={styles.tabla}>
            <thead>
              <tr>
                <th style={styles.th}>Cliente</th>
                <th style={styles.thNum}>Líneas</th>
                <th style={styles.thNum}>Solicitado</th>
                <th style={styles.thNum}>Facturado</th>
                <th style={styles.thNum}>Fill Rate</th>
              </tr>
            </thead>
            <tbody>
              {porCliente.map((c) => (
                <>
                  <tr key={c.cliente} onClick={() => handleClickCliente(c.cliente)} style={styles.filaClickable}>
                    <td style={styles.td}>
                      <span style={styles.flechaExpandir}>{clienteExpandido === c.cliente ? '▾' : '▸'}</span> {c.cliente}
                    </td>
                    <td style={styles.tdNum}>{c.lineas}</td>
                    <td style={styles.tdNum}>{Number(c.total_solicitado).toLocaleString('es-MX')}</td>
                    <td style={styles.tdNum}>{Number(c.total_facturado).toLocaleString('es-MX')}</td>
                    <td style={{ ...styles.tdNum, fontWeight: 700, color: c.pct_fill_rate >= 95 ? '#3E7C5A' : c.pct_fill_rate >= 85 ? '#B8862E' : '#B23A48' }}>
                      {c.pct_fill_rate}%
                    </td>
                  </tr>
                  {clienteExpandido === c.cliente && (
                    <tr key={`${c.cliente}-detalle`}>
                      <td colSpan={5} style={styles.celdaDetalle}>
                        {cargandoLineas ? (
                          <span style={{ fontSize: '11.5px', color: '#8A7690' }}>Cargando líneas...</span>
                        ) : (
                          <table style={styles.tablaDetalle}>
                            <thead>
                              <tr>
                                <th style={styles.thDetalle}>Num OC</th>
                                <th style={styles.thDetalle}>Artículo</th>
                                <th style={styles.thDetalle}>Unidad</th>
                                <th style={styles.thNumDetalle}>Solicitado</th>
                                <th style={styles.thNumDetalle}>Facturado</th>
                                <th style={styles.thNumDetalle}>Fill Rate</th>
                              </tr>
                            </thead>
                            <tbody>
                              {lineasCliente.map((l, idx) => (
                                <tr key={idx} style={l.fill_rate_linea < 100 ? styles.filaDetalleFalla : {}}>
                                  <td style={styles.tdDetalle}>{l.numero_oc}</td>
                                  <td style={styles.tdDetalle}>{l.articulo}</td>
                                  <td style={styles.tdDetalle}>{l.unidad_venta || '—'}</td>
                                  <td style={styles.tdNumDetalle}>{Number(l.cantidad_solicitada).toLocaleString('es-MX')}</td>
                                  <td style={styles.tdNumDetalle}>{Number(l.cantidad_facturada).toLocaleString('es-MX')}</td>
                                  <td style={{ ...styles.tdNumDetalle, fontWeight: 700, color: l.fill_rate_linea >= 100 ? '#3E7C5A' : '#B23A48' }}>
                                    {l.fill_rate_linea}%
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                    </tr>
                  )}
                </>
              ))}
            </tbody>
          </table>
          </div>
      </div>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '900px' },
  encabezado: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '14px', marginBottom: '4px', flexWrap: 'wrap' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '2px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', maxWidth: '520px' },
  botonSync: { flexShrink: 0, padding: '9px 14px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#6A2C75', border: 'none', borderRadius: '8px', cursor: 'pointer', whiteSpace: 'nowrap' },
  mensaje: { fontSize: '13px', margin: '10px 0', fontWeight: 600 },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', marginTop: '16px' },
  seccionTitulo: { fontSize: '13px', fontWeight: 700, color: '#2A1830', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '10px' },
  botonQuitarFiltro: { fontSize: '10.5px', fontWeight: 600, color: '#6A2C75', background: '#EFE9F3', border: '1px solid #A98BB8', borderRadius: '12px', padding: '3px 10px', cursor: 'pointer' },
  filtroFechas: { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px', flexWrap: 'wrap' },
  inputFecha: { padding: '6px 8px', fontSize: '12px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7' },
  botonBuscar: { padding: '6px 14px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#6A2C75', border: 'none', borderRadius: '6px', cursor: 'pointer' },
 cajaBusqueda: { display: 'flex', gap: '8px', alignItems: 'center', margin: '14px 0', flexWrap: 'wrap' },
  inputBusqueda: { flex: 1, maxWidth: '380px', padding: '9px 12px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '8px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7' },
  historicoTabla: { display: 'flex', flexDirection: 'column', gap: '4px' },
  historicoFila: { display: 'flex', alignItems: 'center', gap: '10px', padding: '4px 6px', borderRadius: '6px', cursor: 'pointer' },
  historicoFilaActiva: { background: '#F5F0F7', outline: '1px solid #A98BB8' },
  historicoFecha: { fontSize: '11px', color: '#8A7690', width: '50px', flexShrink: 0 },
  barraFondo: { flex: 1, height: '10px', background: '#F0E9E0', borderRadius: '6px', overflow: 'hidden' },
  barraLlena: { height: '100%', borderRadius: '6px' },
  historicoPct: { fontSize: '11px', fontWeight: 700, width: '40px', textAlign: 'right' },
  historicoLineas: { fontSize: '10px', color: '#8A7690', width: '60px', textAlign: 'right' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '12.5px' },
  th: { textAlign: 'left', padding: '8px 10px', color: '#8A7690', fontSize: '11px', textTransform: 'uppercase', borderBottom: '2px solid #E6DDD2' },
  thNum: { textAlign: 'right', padding: '8px 10px', color: '#8A7690', fontSize: '11px', textTransform: 'uppercase', borderBottom: '2px solid #E6DDD2' },
  td: { padding: '7px 10px', borderBottom: '1px solid #F0E9E0' },
  tdNum: { padding: '7px 10px', textAlign: 'right', borderBottom: '1px solid #F0E9E0' },
  filaClickable: { cursor: 'pointer' },
  flechaExpandir: { color: '#8A7690', fontSize: '10px', marginRight: '4px' },
  celdaDetalle: { padding: '10px 10px 14px 28px', background: '#F5F3F0', borderBottom: '1px solid #F0E9E0' },
  tablaDetalle: { width: '100%', borderCollapse: 'collapse', fontSize: '11.5px' },
  thDetalle: { textAlign: 'left', padding: '5px 8px', color: '#8A7690', fontSize: '10px', textTransform: 'uppercase' },
  thNumDetalle: { textAlign: 'right', padding: '5px 8px', color: '#8A7690', fontSize: '10px', textTransform: 'uppercase' },
  tdDetalle: { padding: '4px 8px' },
  tdNumDetalle: { padding: '4px 8px', textAlign: 'right' },
  filaDetalleFalla: { background: '#FDF3F1' },
};